import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { UserService } from '../shared/services/user/user.service';
import { features, FeatureKey } from '../shared/helpers/tenant.features';

@Injectable({
  providedIn: 'root',
})
export class FeatureGuard {
  constructor(
    private userService: UserService,
    private router: Router,
  ) {}

  async canActivate(next: ActivatedRouteSnapshot): Promise<boolean | UrlTree> {
    const required = next.data?.['requiresFeature'] as FeatureKey | undefined;
    if (required === undefined || features[required]) {
      return true;
    }
    const user = await this.getMe();
    if (user.is_admin || !user.is_buyer) {
      return true;
    }
    this.router.navigate(['/catalog']);
    return true;
  }

  async getMe() {
    const currentUser = await this.userService.getMe().toPromise();
    return currentUser.data;
  }
}
